<template>
  <el-select
    :value="value"
    placeholder="请选择模板"
    style="width: 100%"
    :loading="loading"
    @change="handleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
import mockService from '../../mockService'

export default {
  name: 'TemplateSelect',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    storeId: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      options: []
    }
  },
  watch: {
    storeId: {
      immediate: true,
      handler () {
        this.fetchOptions()
      }
    }
  },
  methods: {
    fetchOptions () {
      this.loading = true
      mockService.getTemplateOptions({
        storeCode: this.storeId || '',
        storeName: '',
        templateName: ''
      }).then(res => {
        this.options = res.data || []
      }).finally(() => {
        this.loading = false
      })
    },
    handleChange (value) {
      const target = this.options.find(item => item.value === value) || {}
      this.$emit('input', value)
      this.$emit('change', {
        value,
        option: target
      })
    }
  }
}
</script>
